// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Achievement_wrapper_QlcwB","active":"Achievement_active_aTWbJ","icon":"Achievement_icon_1lhX2","locked":"Achievement_locked_2ej8N"};